import InputWithIcon from "@mostrans/web-components/components/advanced/Input/InputWithIcon";
import Icon from "@mui/material/Icon";
import { useEffect } from "react";
import { useGlobalFilter } from "../../shared/hooks/useGlobalFilter";

function FilterInputSearch({
    placeholder = "Cari",
    resetOnMount,
    resetOnUnmount,
    ...props
}) {
    const { filter, setFilter, resetFilter } = useGlobalFilter();
    // const [param, setParam] = useSearchParams();

    useEffect(() => {
        if (resetOnMount) {
            resetFilter("search");
        }
        return () => {
            if (resetOnUnmount) {
                resetFilter("search");
            }
        };
    }, [resetFilter, resetOnMount, resetOnUnmount]);
    // useEffect(() => {
    //     if (param.get("search")) {
    //         setFilter({ search: param.get("search") });
    //     }
    //     setParam((p) => {
    //         p.delete("search");
    //         return p;
    //     });
    // }, [setParam, param, setFilter]);
    return (
        <InputWithIcon
            autoFocus
            value={filter.search}
            onChange={(e) => setFilter({ search: e.target.value })}
            startIcon={<Icon className="text-primary-main">search</Icon>}
            placeholder={placeholder}
            {...props}
        />
    );
}

export default FilterInputSearch;
